import { Font, Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { GST_NUMBER } from '../../../constants';
import { formatDate } from '../../../generalFunctions';
import logo from "../../../assests/images/LuktukeLogo.png";
import font from "../../../assests/fonts/ARLRDBD.ttf";

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        padding: 10
    },
    detailColumn: {
        flexDirection: 'column',
        flexGrow: 15,
        textTransform: 'uppercase',
    },
    linkColumn: {
        flexDirection: 'column',
        flexGrow: 2,
        alignSelf: 'flex-end',
        justifySelf: 'flex-end',
    },
    title: {
        fontSize: 12,
        fontWeight: "bold",
        borderStyle: "solid",
        borderColor: "black",
        borderWidth: 2,
        maxWidth: 200,
        textAlign: "left",
        padding: 10,
        marginBottom: 1
    },
    subtitle: {
        flexDirection: "column",
        flexGrow: 2,
        fontSize: 7,
        marginBottom: 1
    },
    image: {
        marginBottom: 1,
        width: 130,
        height: 80
    },
    ronumber: {
        flexDirection: "column",
        flexGrow: 1,
        fontSize: 10,
        fontWeight: "bold",
        marginLeft: 3,

    }
});



Font.register({
    family: "ARLRDBD",
    format: "truetype",
    src: font
});

const Header = (props) => {
    return (
        <>
            <View style={styles.container}>
                <View style={styles.detailColumn}>
                    {!props.hideGst && <Text style={styles.subtitle}>GST Number: {GST_NUMBER}</Text>}
                    <View style={styles.title}>
                        <Text style={{ alignSelf: "center", fontFamily: "ARLRDBD" }} >{props.title}</Text>
                    </View>
                    <View style={{ flexDirection: "row", marginTop: 2 }}>
                        {props.id && <Text style={styles.ronumber}>No. {props.id}</Text>}
                        <Text style={{
                            flexDirection: "column",
                            flexGrow: 2,
                            fontSize: 10,
                        }}>Date: {formatDate(props.date)}</Text>
                    </View>
                </View>
                <View style={styles.linkColumn}>
                    <Image
                        src={logo}
                        style={styles.image}
                    />
                </View>
            </View>
            {/* <View style={{
                flexDirection: "row",
                borderBottomWidth: 1,
                borderBottomColor: 'lightgray',
                borderBottomStyle: 'solid',
                marginBottom: 15,
                marginRight: 30
            }}>
            </View> */}
        </>
    );
}

export default Header;